export default __webpack_public_path__ + "static/media/toastTick.74546b9d.svg";